import {publishOptimisticFields} from '@github-ui/optimistic-connection/connectionMutationBridge'
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  unarchiveProjectItemMutation,
  unarchiveProjectItemMutation$data,
  UnarchiveProjectV2ItemInput,
} from './__generated__/unarchiveProjectItemMutation.graphql'

export function commitUnArchiveProjectItem({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: UnarchiveProjectV2ItemInput
  onError?: (error: Error) => void
  onCompleted?: (response: unarchiveProjectItemMutation$data) => void
}) {
  const publication = publishOptimisticFields(input.itemId, {isArchived: false})

  try {
    return commitMutation<unarchiveProjectItemMutation>(environment, {
      // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
      mutation: graphql`
        mutation unarchiveProjectItemMutation($input: UnarchiveProjectV2ItemInput!) @raw_response_type {
          unarchiveProjectV2Item(input: $input) {
            item {
              isArchived
            }
          }
        }
      `,
      variables: {
        input,
      },
      onError: error => {
        publication.failed(error)
        onError?.(error)
      },
      onCompleted: response => {
        const item = response.unarchiveProjectV2Item?.item
        if (!item) {
          const error = new Error('Failed to restore project item')
          publication.failed(error)
          onError?.(error)
          return
        }

        publication.completed({isArchived: item.isArchived})
        onCompleted?.(response)
      },
      onUnsubscribe: () => publication.failed(new Error('Restoring project item was cancelled')),
    })
  } catch (error) {
    publication.failed(error instanceof Error ? error : new Error('Failed to restore project item'))
    throw error
  }
}
